const getBankName = (bankName) => {
    const allBank = JSON.parse(localStorage.getItem("AllBanks"));
    // console.log(bankName)
    for (let i = 0; i < allBank?.length; i++) {
      if (bankName === allBank[i]._id) {
        return allBank[i].bankName;
      }
    }
  };
  
  const getBankCode = (bankCode) => {
    const allBank = JSON.parse(localStorage.getItem("AllBanks"));
    // console.log(bankName)
    for (let i = 0; i < allBank?.length; i++) {
      if (bankCode === allBank[i]._id) {
        return allBank[i].bankCode;
      }
    }
  };
  
  const changeTypeToName = (data) => {
    switch (data) {
      case "bon_6":
        return "หกตัวตรง";
      case "bon_5":
        return "ห้าตัว";
      case "bon_4":
        return "สี่ตัว";
      case "bon_3":
        return "สามตัวบน";
      case "bon_2":
        return "สองตัวบน";
      case "bon_1":
        return "วิ่งบน";
      case "lang_3":
        return "สามตัวล่าง";
      case "lang_2":
        return "สองตัวล่าง";
      case "lang_1":
        return "วิ่งล่าง";
      case "tode_3":
        return "สามตัวโต๊ด";
      case "na_3":
        return "สามตัวหน้า";
      case "withdraw":
        return "ถอน";
      case "deposit":
        return "ฝาก";
      default:
        break;
    }
  };
  
  const changeGroupToName = (data) => {
    switch (data) {
      case "Thai":
        return "หวยไทย";
      case "Yeekee":
        return "หวยยี่กี";
      case "Laos":
        return "หวยลาว";
      case "Hanoi":
        return "หวยฮานอย";
      case "Malay":
        return "หวยมาเลย์";
      case "StockMarket":
        return "หวยหุ้น";
      default:
        break;
    }
  };
  
  const changeOptionTypeToName = (data) => {
    switch (data) {
      case "reverse":
        return "โหมดกลับ";
      case "19_door":
        return "โหมด19ประตู";
      case "double_number":
        return "โหมดเลขเบิ้ล";
      case "front_number":
        return "โหมดรูดหน้า";
      case "back_number":
        return "โหมดรูดหลัง";
      case "low_number":
        return "โหมด2ตัวต่ำ";
      case "high_number":
        return "โหมด2ตัวสูง";
      case "odd_number":
        return "โหมดเลขคี่";
      case "even_number":
        return "โหมดเลขคู่";
      default:
        return "";
    }
  };
  
  const changeBetTypeToName = (data) => {
    switch (data) {
      case "head":
        return "หัว";
      case "tail":
        return "ก้อย";
      case "random":
        return "สุ่มตัวเลือก";
      case "scissors":
        return "กรรไกร";
      case "rock":
        return "ค้อน";
      case "paper":
        return "กระดาษ";
      case 1:
        return "⚀";
      case 2:
        return "⚁";
      case 3:
        return "⚂";
      case 4:
        return "⚃";
      case 5:
        return "⚄";
      case 6:
        return "⚅";
      default:
        return "";
    }
  };
  
  export {
    getBankName,
    changeTypeToName,
    changeGroupToName,
    changeOptionTypeToName,
    changeBetTypeToName,
    getBankCode
  };
  